import {
  CheckCircle,
  XCircle,
  PauseCircle,
  PieChart,
  AlertCircle,
  XSquare,
} from "react-feather";
import { IconType } from "react-icons";

import { AccreditationTypes } from "@/types/accreditation";

export const accreditationTypes = [
  AccreditationTypes.PENDING,
  AccreditationTypes.GRANTED,
  AccreditationTypes.INCOMPLETE,
  AccreditationTypes.REJECTED,
  AccreditationTypes.CANCELED,
];

export const accreditationColors: { [key in AccreditationTypes]: string } = {
  [AccreditationTypes.PENDING]: "#fdcb6e",
  [AccreditationTypes.CANCELED]: "#e17055",
  [AccreditationTypes.GRANTED]: "#28a745",
  [AccreditationTypes.INCOMPLETE]: "#636e72",
  [AccreditationTypes.REJECTED]: "#dc3545",
  [AccreditationTypes.WITHDRAWN]: "#a8a8a8",
};

export const accreditationIcons: { [key in AccreditationTypes] } = {
  [AccreditationTypes.PENDING]: PauseCircle,
  [AccreditationTypes.CANCELED]: AlertCircle,
  [AccreditationTypes.GRANTED]: CheckCircle,
  [AccreditationTypes.INCOMPLETE]: PieChart,
  [AccreditationTypes.REJECTED]: XCircle,
  [AccreditationTypes.WITHDRAWN]: XSquare,
};

export const getAccreditationStatusColor = (status: string): string =>
  accreditationColors[status] ?? undefined;

export const getAccreditationStatusIcon = (status: string): IconType =>
  accreditationIcons[status] ?? undefined;

export const getAccreditationFieldFilePath = (value): string | null => {
  if (!value) return null;
  if (typeof value === "string") return value;

  return value?.path ?? value?.filename ?? null;
};

export const getAccreditationPhoto = (fields): string | null => {
  const photoField = fields?.find(
    (field) =>
      field?.accreditationField?.default &&
      field?.accreditationField?.name?.en === "photo" &&
      getAccreditationFieldFilePath(field?.value)
  );

  return getAccreditationFieldFilePath(photoField?.value);
};
